import Axios from 'axios'

//host
import { host } from '../../../constant/host'

//help
import checkIsSuccessAction from '../../../helper/checkIsSuccessAction';
import mapErrors from '../../../helper/mapErrors';

//types
import * as types from './types'


const apiGetMerchantCount = `${host}/merchant/chain/count`

export const getMerchantCount = (callbackSuccess) => async dispatch => {
   
    try {
        const res = await Axios.post(apiGetMerchantCount);
        const { data } = res
        if (checkIsSuccessAction(data.code)) {
            dispatch({
                type: types.GET_MERCHANT_COUNT,
                payload: {
                    ...data
                }
            })
            callbackSuccess && callbackSuccess()
        }
        else {
            dispatch({
                type: types.GET_MERCHANT_COUNT_ERR,
                payload: {
                    ...data
                }
            })
        }
    } catch (error) {
        dispatch(mapErrors(error, types.GET_MERCHANT_COUNT_ERR))
    }
}
